import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    placeholder: String,
    maxOptions: Number,
    allowEmptyOption: Boolean
  }

  connect() {
    if (this.element.tomselect) return

    this.beforeCacheHandler = this.beforeCache.bind(this)
    document.addEventListener("turbo:before-cache", this.beforeCacheHandler)

    this.instance = new TomSelect(this.element, {
      create: false,
      allowEmptyOption: this.hasAllowEmptyOptionValue ? this.allowEmptyOptionValue : true,
      maxOptions: this.hasMaxOptionsValue ? this.maxOptionsValue : 500,
      placeholder: this.hasPlaceholderValue ? this.placeholderValue : undefined
    })
  }

  disconnect() {
    this.destroy()
  }

  beforeCache() {
    this.destroy()
  }

  destroy() {
    if (this.instance) {
      this.instance.destroy()
      this.instance = null
    }

    if (this.beforeCacheHandler) {
      document.removeEventListener("turbo:before-cache", this.beforeCacheHandler)
      this.beforeCacheHandler = null
    }
  }
}
